// Display order only. Preserve every source label and record independently.
const sizeCollator = new Intl.Collator("tr", { numeric: true });
const apparel = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL", "XXXXXL", "XXXXXXL"];
const unknownSizes = new Set(["", "—", "-", "BİLGİ YOK", "BILGI YOK", "UNKNOWN"]);
function sizePosition(label: string): [number, number] {
  const normalized = label.trim().toLocaleUpperCase("tr-TR");
  const alias = /^([2-6])XL$/.exec(normalized);
  const rank = apparel.indexOf(alias ? "X".repeat(Number(alias[1])) + "L" : normalized);
  // Recognize 3XL as apparel before considering numeric shoe/waist sizes.
  return rank >= 0 ? [1, rank] : unknownSizes.has(normalized) ? [3, 0] : /^\d/.test(normalized) ? [0, 0] : [2, 0];
}
export function compareProductDetailSizes(a: string, b: string) {
  const aa = sizePosition(a), bb = sizePosition(b);
  return aa[0] - bb[0] || aa[1] - bb[1] || sizeCollator.compare(a, b);
}
export function orderProductDetailSizes<T>(rows: readonly T[], label: (row: T) => string): T[] {
  return [...rows].sort((a, b) => compareProductDetailSizes(label(a), label(b)));
}
export function productDetailTotalLabel(language: string) {
  return ({ tr: "GENEL TOPLAM", en: "GRAND TOTAL", ru: "ОБЩИЙ ИТОГ", uz: "UMUMIY JAMI" } as Record<string, string>)[language] ?? "GENEL TOPLAM";
}
